import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { MODALS } from '@lib/tools/shared/helpers/consts';

export type TModalTypes = (typeof MODALS)[keyof typeof MODALS];
type IState = {
  modalState: Record<TModalTypes, boolean>;
};

export const initialState: IState = {
  modalState: {
    [MODALS.TERMS_OF_SERVICE_BASIC_MODAL]: false,
    [MODALS.DOWNLOAD_APP_MODAL]: false,
    [MODALS.FOOD_PREFERENCES_MODAL]: false,
    [MODALS.MANAGE_MODAL]: false,
    [MODALS.THIRD_PARTY_CONNECT_MODAL]: false,
    [MODALS.DISCOVERY_QUIZ_MODAL]: false,
  },
};

export const modalsSlice = createSlice({
  initialState,
  name: 'modals',
  reducers: {
    actionModalClose: state => {
      state.modalState = initialState.modalState;
    },
    actionModalOpen: (state, action: PayloadAction<{ modalName: TModalTypes }>) => {
      state.modalState[action.payload.modalName] = true;
    },
    actionToggleModal: (state, action: PayloadAction<{ modalName: TModalTypes }>) => {
      const { modalName } = action.payload;
      state.modalState[modalName] = !state.modalState[modalName];
    },
  },
});

export default modalsSlice.reducer;
export const { actionModalOpen, actionModalClose, actionToggleModal } = modalsSlice.actions;
